/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Build_Deliverable_ValueInputs */

const en_how_we_work_build_deliverable_value = /** @type {(inputs: How_We_Work_Build_Deliverable_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working software, sample runs, and agreed limits and approval rules.`)
};

const lv_how_we_work_build_deliverable_value = /** @type {(inputs: How_We_Work_Build_Deliverable_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strādājoša programmatūra, testa palaišanas, saskaņotas robežas un apstiprināšanas noteikumi.`)
};

/**
* | output |
* | --- |
* | "Working software, sample runs, and agreed limits and approval rules." |
*
* @param {How_We_Work_Build_Deliverable_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_build_deliverable_value = /** @type {((inputs?: How_We_Work_Build_Deliverable_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Build_Deliverable_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_build_deliverable_value(inputs)
	return en_how_we_work_build_deliverable_value(inputs)
});